module.exports = __webpack_public_path__ + "static/img/w_logo_max_b.deeda8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/w_logo_max_b.png
// module id = e5FY
// module chunks = 47